// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/minimize-2.js';

import { paths } from '../generated/minimize-2';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('minimize-2', Original, paths);
